import { render, staticRenderFns } from "./TheMinicartAside.vue?vue&type=template&id=6eef45c8&"
import script from "./TheMinicartAside.vue?vue&type=script&lang=js&"
export * from "./TheMinicartAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports